import { useScrollReveal } from "@/hooks/useScrollReveal";

const fleet = [
  {
    name: "BYD",
    category: "Sedan Executivo",
    passengers: 3,
    luggage: 3,
    tag: "Mais Popular",
    image: "https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/545baa2f64085239c3c57c5fcd857609.png",
  },
  {
    name: "Ranger Rover",
    category: "Sedan Premium",
    passengers: 3,
    luggage: 3,
    tag: "Luxo",
    image: "https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/877d4f4004a82abded09995a4f33991d.png",
  },
  {
    name: "Range Rover Vogue",
    category: "SUV Executivo",
    passengers: 5,
    luggage: 4,
    tag: "SUV Premium",
    image: "https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/3600909074179d60ece3433fdbd0102a.png",
  },
  {
    name: "TOYOTA",
    category: "Van Executiva",
    passengers: 8,
    luggage: 8,
    tag: "Grupos",
    image: "https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/18180054ced3fc52ed378b738c759f32.png",
  },
  {
    name: "NISSAN",
    category: "Sedan de Luxo",
    passengers: 3,
    luggage: 3,
    tag: "Exclusivo",
    image: "https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/0261c02b8ff955cde633265bd3c92d4b.png",
  },
  {
    name: "CHEVROLET",
    category: "SUV Conforto",
    passengers: 6,
    luggage: 5,
    tag: "Família",
    image: "https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/61cf146603102b8be6c611cfb4a8ea98.png",
  },
];

interface FleetCardProps {
  car: {
    name: string;
    category: string;
    passengers: number;
    luggage: number;
    tag: string;
    image: string;
  };
  idx: number;
}

function FleetCard({ car, idx }: FleetCardProps) {
  const card = useScrollReveal({ threshold: 0.1, rootMargin: "0px 0px -40px 0px" });
  return (
    <div
      ref={card.ref}
      style={{ transitionDelay: `${idx * 80}ms` }}
      className={`group bg-zinc-900 border border-zinc-800 hover:border-slate-500/50 rounded-lg overflow-hidden transition-all duration-500 cursor-pointer ${
        card.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      }`}
    >
      {/* Image */}
      <div className="relative h-52 bg-zinc-800 overflow-hidden">
        <img
          src={car.image}
          alt="Carro Premium"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <span className="absolute top-4 left-4 text-xs font-bold text-black bg-slate-300 px-3 py-1 rounded-full">
          Carro Premium
        </span>
      </div>

      {/* Info */}
      <div className="p-6">
        <a
          href={`https://wa.me/5519974056980?text=${encodeURIComponent(`Olá! Gostaria de solicitar um veículo premium. Poderia me passar mais informações?`)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full block text-center bg-slate-400/10 hover:bg-slate-300 border border-slate-400/40 hover:border-slate-300 text-slate-300 hover:text-black font-semibold py-2.5 rounded-md transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
        >
          Solicitar Este Veículo
        </a>
      </div>
    </div>
  );
}

export default function FleetSection() {
  const header = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="fleet" className="bg-zinc-950 py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div
          ref={header.ref}
          className={`text-center mb-16 transition-all duration-700 ${
            header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-12 bg-slate-400"></div>
            <span className="text-slate-300 text-sm font-semibold tracking-widest uppercase">
              Veículos Premium
            </span>
            <div className="h-px w-12 bg-slate-400"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Nossa <span className="text-slate-300">Frota</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Veículos de última geração, impecavelmente mantidos para proporcionar a melhor experiência de viagem.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {fleet.map((car, idx) => (
            <FleetCard key={idx} car={car} idx={idx} />
          ))}
        </div>

        {/* Footer text */}
        <div className="text-center mt-12">
          <p className="text-gray-400 text-lg">
            Temos esses e muito mais modelos...{" "}
            <a
              href={`https://wa.me/5519974056980?text=${encodeURIComponent("Olá! Gostaria de conhecer todos os modelos disponíveis na frota. Poderia me ajudar?")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-300 hover:text-white font-semibold underline underline-offset-4 transition-colors duration-300 cursor-pointer"
            >
              Fale conosco e descubra!
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
